import { useToast } from "@chakra-ui/react";

import { Organisation } from "@nens/brostar/openapi-client";

import { getApi } from "@/api/api-configuration";

import { useInvalidateImportTaskListQuery } from "../../../queries/query-import-task";

const api = getApi();

export const useStartBroIdImport = () => {
  const invalidateImportTaskList = useInvalidateImportTaskListQuery();
  const toast = useToast();

  const showToast = (title: string, status: "error" | "success" | "info", description?: string) => {
    toast({ title, description, status, duration: 9000, isClosable: true });
  };

  return async (organisation: Organisation, broId: string) => {
    try {
      // Data Owner and BRO-domain are assigned based on userprofile and BRO-ID, so we don't need to pass them here.
      await api.apiObjectimporttasksCreate({
        data: { broId, force: true },
      });

      showToast(`Import gestart voor ${broId}.`, "success");
    } catch (error) {
      showToast(
        `Import mislukt voor ${broId}`,
        "error",
        error instanceof Error ? error.message : "Unknown error"
      );
    }

    await invalidateImportTaskList();
  };
};
